// import axios from 'axios';
import { UserDetail } from "../../../services/storage.service";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("users");
const athleteRepository = RepositoryFactory.get("athlete");

const state = {
  profileList: [],
  athleteId: UserDetail.getUserID(),
  profileId: "",
  editProfileData: {},
};

const getters = {
  getProfileList: (state) => state.profileList,
  getEditProfileData: (state) => state.editProfileData,
  getprofileId: (state) => state.profileId,
};

const actions = {
  // Set Profile List
  setProfileList({ commit }) {
    UserRepository.getUsersInfo()
      .then((response) => {
        commit('profileListSetter', response.data.athleteProfiles);
      })
      .catch(({ error }) => {
        this.$message.warning(error);
      });
  },

  setProfileData({ commit }, id) {
    athleteRepository
      .getAthleteInfo(id)
      .then((response) => {
        commit('setEditProfileData', response.data.mainAthlete)
      })
  },

  // Player Profile Functions
  setGeneralInfo({ commit, state }, values) {
    let toSend = {
      athleteId: state.athleteId,
      athletename: values.name,
      state: values.state,
      birthDay: values.day,
      birthMonth: values.month,
      birthYear: values.year,
      heightInFeet: values.feet,
      heightInInch: values.inch,
      weight: values.weight,
      profileType: "Incomplete",
      country: "USA",
    };
    athleteRepository
      .registerPlayer(toSend)
      .then((response) => {
        commit('addProfile', response.data.mainAthlete);
      })
  },

  setPlayerDetailInfo({ commit }, { values, id }) {
    athleteRepository
      .editPlayerData(values, id)
  },

  addPlayerImages({ commit, state }, { data, id }) {
    athleteRepository
      .postPlayerImages(data, id)
  },
  addPlayerVideos({ commit }, { data, id }) {
    let toSend = {
      atheleteMainProfileId: id,
      videoDesc: data.videoDesc,
      videoUrl: data.videoUrl
    };
    athleteRepository
      .postPlayerVideos(toSend)
  },

  addPlayerTeams({ commit, state }, { data, id }) {
    let toSend = {
      atheleteMainProfileId: id,
      name: data.name,
      level: data.level,
      position: data.position,
      coachName: data.coachName,
      coachEmail: data.coachEmail,
      coachPhone: data.coachPhone,
      slug: 'athlete',
    };
    athleteRepository
      .postPlayerTeams(toSend)
  },
};

const mutations = {
  // Profile Detail mutations
  profileListSetter: (state, data) => (
    (state.profileList = data)
  ),

  setEditProfileData: (state, data) => (
    (state.editProfileData = data)
  ),

  addProfile: (state, data) => (
    (state.profileId = data.id),
    (state.profileList = [...state.profileList, data])
  ),
};

export default {
  state,
  getters,
  actions,
  mutations
};
